import { Box, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getHistoryMerchant,
  getHistoryMerchantFilterConditions,
} from "../../services/services";
import { pageNumber, rowsPerPage } from "../../utils/constants";
import Label from "../Label";
import TableView from "../Table";
import Scrollbar from "../table/Scrollbar";
import CircularLoader from "../circularLoader";
import FormSearch from "../FormSearch";
import CommonDialog from "../CustomDialog";
import MerchantDetails from "../../pages/details/admin/MerchantDetails";
import HeaderHelpPage from "../HeaderHelpPage";

const HistoryMerchant = () => {
  const [historyMerchant, setHistoryMerchant] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [itemId, setItemId] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [filter, setFilter] = useState({});
  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // ------------------ filterStuffies --------------------//

  const onFilterSubmit = (data) => {
    const newPrams = {
      ...data,
      business_entity: data?.business_entity?.id,
      name_input: inputValues?.name?.trim() || null,
      mid_input: inputValues?.mid?.trim() || null,
      business_entity_input: inputValues?.business_entity?.trim() || null
    }
    const newPagination = {
      ...pagination,
      page: 1,
    };
    setLoaded(false);
    setFilter(newPrams);
    getHistoryMerchant({
      setResponse: setHistoryMerchant,
      filter: newPrams,
      queryParams: newPagination,
      setLoaded
    });
    setPagination(newPagination);
  };

  useEffect(() => {
      getHistoryMerchantFilterConditions(setFParams);
      getHistoryMerchant({
        setResponse: setHistoryMerchant,
        filter: {},
        queryParams: pagination,
        setLoaded: setLoaded,
      });
  }, []);

  const getNext = (queryParams) => {
    setLoaded(false);
    getHistoryMerchant({
      setResponse: setHistoryMerchant,
      filter: filter,
      queryParams: queryParams,
      setLoaded
    });
    setPagination(queryParams);
  };

  const formatData = (input) => {
    let tableData = [];
    input.forEach(
      ({
        id,
        action,
        is_approved,
        oxygen7_entity,
        // registered_country,
        name,
        business_entity,
        mid,
      }) => {
        tableData.push({
          id: id,
          name: name ? name.toUpperCase() : "",
          MID: mid,
          business_entity: business_entity && business_entity.business_name?.toUpperCase(),
          oxygen7_entity: oxygen7_entity && oxygen7_entity.entity,
          // registered_country:
          //   registered_country && registered_country.registered_country,
          action: action,
          approved: (
            <>
              <Label variant="ghost" color={is_approved ? "success" : "error"}>
                {is_approved ? "YES" : "NO"}
              </Label>
            </>
          ),
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (historyMerchant?.results) {
      setTableData(formatData(historyMerchant.results));
    }
  }, [historyMerchant]);

  const schema = [
    {
      type: "search-select",
      label: "Name",
      param: "name",
      options: fParams?.name?.map((name) => name),
      inputValues,
      setInputValues,
    },
    {
      type: "search-select",
      label: "MID",
      param: "mid",
      options: fParams?.mid?.map(item => item),
      inputValues,
      setInputValues,
    },
    {
      type: "search-select",
      label: "Business Entity",
      param: "business_entity",
      options: fParams?.business_entity?.map((entity) => ({
        label: entity.business_entity__business_name,
        id: entity.business_entity__id,
      })),
      inputValues,
      setInputValues,
    },
    {
      type: "select",
      label: "Oxygen7 Entity",
      param: "oxygen7_entity",
      options: fParams?.oxygen7_entity?.map((entity) => ({
        name: entity.entity,
        id: entity.id,
      })) || [],
    },
    // {
    //   type: "select",
    //   label: "Registered Country",
    //   param: "registered_country",
    //   options: fParams?.registered_country?.map((country) => ({
    //     id: country.registered_country__id,
    //     name: country.registered_country__registered_country,
    //   }))
    // },
    {
      type: "select",
      label: "Action",
      param: "action",
      id: false,
      options: ["Add", "Remove", "Update", "Suspend", "Unsuspend"]
    },
    {
      type: "select",
      label: "Approved",
      param: "is_approved",
      options: [
        { name: "Yes", id: true },
        { name: "No", id: false },
      ]
    }
  ]

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={false}
        onSearch={onFilterSubmit}
      />
      {loaded ?
        <Card>
          <Scrollbar>
            {tableData && (
              <TableView
                link={`/3/app/merchant-details~id~?action=true`}
                onSelectItem={(id) => setItemId(id)}
                rows={tableData}
                count={historyMerchant.count}
                pagination={pagination}
                getNext={getNext}
                query={filterName}
                data={tableData}
              />
            )}
          </Scrollbar>
        </Card>
        :
        <CircularLoader />
      }

      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Merchant Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <MerchantDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Box>
  );
};

export default HistoryMerchant;
